import React, { useState } from 'react';
import { Delete } from '../../styled';
import IconButton from 'Common/Components/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { showCredentialModalDelete } from 'store/Credentials/actions';
import { useIntl } from 'react-intl';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import ModalWarning from 'Common/Components/ModalWarning';
import get from 'lodash/get';

const DeleteButton = ({ rowInfo }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showWarning, setShowWarning] = useState(false);
  const id = get(rowInfo, 'original.id', '');
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const message = intl.formatMessage(
    { id: 'modalWarning.selectOneOrMore' },
    { entity: 'Credential' }
  );

  const onClick = () => {
    if (credentialsSelected.length > 0 || id) dispatch(showCredentialModalDelete(true, id));
    else setShowWarning(true);
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <IconButton icon={ <Delete /> } title={ false } onClick={ onClick } />
      {showWarning && (
        <ModalWarning
          onCloseCallback={ onClose }
          title="Delete Credential"
          description={ message }
        />
      )}
    </>
  );
};

export default DeleteButton;
